// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  --page-margin: var(--app-fair-margin);
  --page-background: var(--app-background);
  --page-border-radius: var(--app-fair-radius);
  --page-tags-vertical-gutter: 2px;
  --page-tags-horizontal-gutter: 4px;
  --page-places-gutter: 5px;
  --page-friends-gutter: calc(var(--page-margin) / 2);
  --page-visits-gutter: calc(var(--page-margin) / 2);
  --page-swiper-pagination-space: 140px;
  --page-swiper-pagination-height: 18px;
  --page-pagination-bullet-size: 10px;
  --page-color: #00AFFF;
}

:host ::ng-deep .swiper-pagination {
  height: var(--page-swiper-pagination-height);
  line-height: 1;
  bottom: calc((var(--page-swiper-pagination-space) - var(--page-swiper-pagination-height)) / 2);
}
:host ::ng-deep .swiper-pagination .swiper-pagination-bullet {
  width: var(--page-pagination-bullet-size);
  height: var(--page-pagination-bullet-size);
  background: white;
}

#recommendedViewpoint {
  margin: 0 0 16px 0;
  /* border-radius: 10px; */
  overflow: hidden;
}
#recommendedViewpoint .covers .image-container {
  width: 100%;
  /* Ancho completo */
  height: 0;
  /* Altura inicial */
  padding-bottom: 100%;
  /* Esto crea una relación de aspecto cuadrada */
  position: relative;
  /* Posicionamiento relativo para los hijos absolutos */
  overflow: hidden;
  /* Oculta cualquier parte de la imagen que sobresalga */
}
#recommendedViewpoint .covers .image-container img {
  position: absolute;
  top: 50%;
  /* Centra la imagen verticalmente */
  left: 50%;
  /* Centra la imagen horizontalmente */
  width: auto;
  /* Ancho completo dentro del contenedor */
  height: 100%;
  /* Altura automática para mantener la relación de aspecto de la imagen */
  transform: translate(-50%, -50%);
  /* Ajuste fino para centrar exactamente la imagen */
  object-fit: cover;
  /* Asegura que la imagen cubra completamente el contenedor */
}
#recommendedViewpoint .covers .buttons-container {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 10px;
  /* Espacio entre botones */
  padding: 10px;
  /* Espacio desde el borde superior derecho */
  z-index: 1;
}
#recommendedViewpoint .covers .buttons-container ion-button {
  background-color: rgba(255, 255, 255, 0.7);
  /* Blanco con transparencia */
  --opacity: 0.7;
  /* Transparencia para el contenido del botón */
}
#recommendedViewpoint .covers .buttons-container ion-icon {
  color: #000;
  /* Color de los iconos */
}
#recommendedViewpoint .covers .icons-container {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 10px;
  /* Espacio entre iconos */
  padding: 12px 20px;
  /* Espacio desde el borde superior derecho */
  z-index: 1;
}
#recommendedViewpoint .covers .icons-container ion-icon {
  font-size: 28px;
  /* Tamaño del icono */
  color: rgba(255, 255, 255, 0.9);
  /* Color blanco con transparencia */
  cursor: pointer;
  /* Cambia el cursor al pasar el mouse */
}
#recommendedViewpoint .bodyRecomended,
#recommendedViewpoint .bodyRecomendedV {
  padding: 24px;
  text-align: center;
  z-index: 20;
  position: relative;
  border-radius: 40px 40px 0 0;
  min-height: 20px;
  background: var(--ion-linear-gradient);
  transition: margin-top 0.4s ease;
}
#recommendedViewpoint .bodyRecomended {
  margin-top: -337px;
}
#recommendedViewpoint .bodyRecomended .title {
  font-size: 28px;
}
#recommendedViewpoint .bodyRecomended .description {
  margin: 24px 0;
}
#recommendedViewpoint .bodyRecomendedV {
  margin-top: -52px;
}
#recommendedViewpoint .bodyRecomendedV .title {
  font-size: 28px;
}
#recommendedViewpoint .bodyRecomendedV .description {
  margin: 24px 0;
}
#recommendedViewpoint .card-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
#recommendedViewpoint .card-content .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  font-size: 18px;
  font-weight: 500;
}
#recommendedViewpoint .card-content .duration {
  font-size: 14px;
  color: gray;
}
#recommendedViewpoint .card-content .rating {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 0 0 5px 5px;
}
#recommendedViewpoint .card-content .rating ion-icon {
  margin-right: 8px;
}
#recommendedViewpoint .card-content .price {
  font-size: 16px;
  font-weight: 500;
}

.loading-shell {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  /* Para crear un contenedor cuadrado */
  background-color: #f5f5f5;
  /* Color de fondo del shell */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading {
  width: 100%;
  height: 100%;
  background-color: #ccc;
  /* Color gris para el efecto de carga */
  opacity: 0.4;
  /* Opacidad para el efecto de carga */
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.loaded {
  opacity: 1;
  /* Mostrar la imagen cuando esté cargada */
  transition: opacity 0.3s ease-in-out;
}

.install-banner {
  color: #fff;
  padding: 4px;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1000;
}
.install-banner ion-item {
  background: rgba(255, 255, 255, 0.2);
  /* Fondo blanco con 20% de opacidad */
  border-radius: 8px;
  /* Opcional: para redondear los bordes */
  margin-bottom: 10px;
  /* Espaciado entre los elementos */
}
.install-banner ion-avatar img {
  opacity: 0.9;
  /* Imagen con 90% de opacidad */
}
.install-banner ion-label h3,
.install-banner ion-label p {
  opacity: 0.9;
  /* Texto con 90% de opacidad */
}
.install-banner ion-button {
  opacity: 0.9;
  /* Botón con 90% de opacidad */
}
.install-banner ion-icon {
  opacity: 0.9;
  /* Iconos con 90% de opacidad */
}

.install-banner a {
  color: #00ff00;
  font-weight: bold;
  text-decoration: none;
}

.install-banner button {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  margin-left: 20px;
}

ion-avatar {
  --border-radius: 4px;
}

.more-experiences-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  /* border-bottom: 1px solid var(--ion-color-light-shade); */
}
.more-experiences-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
}
.more-experiences-section .heading-row .heading-title {
  margin: 0px;
  flex-basis: 68%;
}
.more-experiences-section .heading-row .heading-call-to-action {
  /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.more-experiences-section .experiences-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.more-experiences-section .experiences-row::-webkit-scrollbar {
  display: none;
}
.more-experiences-section .experiences-row::before, .more-experiences-section .experiences-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));
}
.more-experiences-section .experiences-row .experience-item {
  --col-item-width: 3;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-friends-gutter);
}
.more-experiences-section .experiences-row .experience-item .experience-name {
  display: block;
  text-align: left;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  padding-left: 4px;
}
.more-experiences-section .experiences-row .experience-item app-image-shell.experience-picture {
  --image-shell-border-radius: var(--page-border-radius);
}
.more-experiences-section .experiences-row .experience-item .experience-name > app-text-shell {
  --text-shell-line-height: 14px;
}

.guides-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  /* border-bottom: 1px solid var(--ion-color-light-shade); */
}
.guides-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
}
.guides-section .heading-row .heading-title {
  margin: 0px;
  flex-basis: 68%;
}
.guides-section .heading-row .heading-call-to-action {
  /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.guides-section .guides-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.guides-section .guides-row::-webkit-scrollbar {
  display: none;
}
.guides-section .guides-row::before, .guides-section .guides-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));
}
.guides-section .guides-row .guide-item {
  --col-item-width: 5;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-friends-gutter);
}
.guides-section .guides-row .guide-item .guide-name {
  display: block;
  text-align: left;
  margin: var(--page-margin) 0px;
  font-size: 14px;
  padding-left: 4px;
}
.guides-section .guides-row .guide-item app-image-shell.guide-picture {
  --image-shell-border-radius: var(--page-border-radius);
}
.guides-section .guides-row .guide-item .guide-name > app-text-shell {
  --text-shell-line-height: 14px;
}

.user-friends-section {
  margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);
  padding-bottom: var(--page-margin);
  border-bottom: 1px solid var(--ion-color-light-shade);
}
.user-friends-section .heading-row {
  margin-bottom: var(--page-margin);
  justify-content: space-between;
  align-items: center;
}
.user-friends-section .heading-row .details-section-title {
  margin: 0px;
}
.user-friends-section .heading-row .heading-call-to-action {
  padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4);
  text-decoration: none;
  color: var(--ion-color-secondary);
}
.user-friends-section .friends-row {
  --ion-grid-columns: 7;
  --ion-grid-column-padding: 0px;
  flex-wrap: nowrap;
  overflow-x: scroll;
  will-change: scroll-position;
  margin-left: calc(var(--page-margin) * -1);
  margin-right: calc(var(--page-margin) * -1);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
}
.user-friends-section .friends-row::-webkit-scrollbar {
  display: none;
}
.user-friends-section .friends-row::before, .user-friends-section .friends-row::after {
  content: "";
  flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));
}
.user-friends-section .friends-row .friend-item {
  --col-item-width: 2;
  flex: 0 0 calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  max-width: calc(var(--col-item-width) / var(--ion-grid-columns, 12) * 100%);
  padding: 0px var(--page-friends-gutter);
}
.user-friends-section .friends-row .friend-item .friend-name {
  display: block;
  text-align: center;
  margin: var(--page-margin) 0px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/start/start.page.scss","webpack://./src/theme/mixins/scrollbars.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB;EACI,qCAAA;EACA,wCAAA;EACA,4CAAA;EAEA,gCAAA;EACA,kCAAA;EACA,yBAAA;EACA,mDAAA;EACA,kDAAA;EAEA,qCAAA;EACA,qCAAA;EACA,mCAAA;EAEA,qBAAA;AALJ;;AAWA;EACI,4CAAA;EACA,cAAA;EAEA,8FAAA;AATJ;AAYI;EACI,yCAAA;EACA,0CAAA;EACA,iBAAA;AAVR;;AAiBA;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;AAdJ;AAkBQ;EACI,WAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,+CAAA;EACA,kBAAA;EACA,sDAAA;EACA,gBAAA;EACA,uDAAA;AAhBZ;AAkBY;EACI,kBAAA;EACA,QAAA;EACA,mCAAA;EACA,SAAA;EACA,qCAAA;EACA,WAAA;EACA,yCAAA;EACA,YAAA;EACA,wEAAA;EACA,gCAAA;EACA,mDAAA;EACA,iBAAA;EACA,4DAAA;AAhBhB;AAoBQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,SAAA;EACA,0BAAA;EACA,aAAA;EACA,4CAAA;EACA,UAAA;AAlBZ;AAoBY;EACI,0CAAA;EACA,6BAAA;EACA,cAAA;EACA,8CAAA;AAlBhB;AAqBY;EACI,WAAA;EACA,wBAAA;AAnBhB;AAwBQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,UAAA;AAtBZ;AAwBY;EACI,eAAA;EACA,qBAAA;EACA,+BAAA;EACA,mCAAA;EACA,eAAA;EACA,uCAAA;AAtBhB;AA+BI;;EAEI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sCAAA;EACA,gCAAA;AA7BR;AAiCI;EACI,kBAAA;AA/BR;AAiCQ;EACI,eAAA;AA/BZ;AAkCQ;EACI,cAAA;AAhCZ;AAoCI;EACI,iBAAA;AAlCR;AAoCQ;EACI,eAAA;AAlCZ;AAqCQ;EACI,cAAA;AAnCZ;AAuCI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AArCR;AAuCQ;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AArCZ;AAwCQ;EACI,eAAA;EACA,WAAA;AAtCZ;AAyCQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAvCZ;AAyCY;EACI,iBAAA;AAvChB;AA2CQ;EACI,eAAA;EACA,gBAAA;AAzCZ;;AA8CA;EACI,WAAA;EACA,SAAA;EACA,oBAAA;EACA,sCAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3CJ;;AA8CA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,YAAA;EACA,qCAAA;EACA,8BAAA;AA3CJ;;AA8CA;EACI;IACI,UAAA;EA3CN;EA8CE;IACI,YAAA;EA5CN;EA+CE;IACI,UAAA;EA7CN;AACF;AAgDA;EACI,UAAA;EACA,0CAAA;EACA,oCAAA;AA9CJ;;AAkDA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AA/CJ;AAiDI;EACI,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,kCAAA;AA/CR;AAkDI;EACI,YAAA;EACA,+BAAA;AAhDR;AAmDI;;EAEI,YAAA;EACA,8BAAA;AAjDR;AAoDI;EACI,YAAA;EACA,8BAAA;AAlDR;AAqDI;EACI,YAAA;EACA,+BAAA;AAnDR;;AAuDA;EACI,cAAA;EACA,iBAAA;EACA,qBAAA;AApDJ;;AAuDA;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AApDJ;;AAuDA;EACI,oBAAA;AApDJ;;AAwDA;EACI,0EAAA;EACA,kCAAA;EACA,2DAAA;AArDJ;AAuDI;EACI,iCAAA;EACA,8BAAA;EACA,mBAAA;AArDR;AAuDQ;EACE,WAAA;EACA,eAAA;AArDV;AAwDQ;EACE,wEAAA;EACA,qBAAA;EACA,iCAAA;AAtDV;AA0DI;EACI,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;EC5UN,wBAAA;EAGA,8BAAA;EACA,qBAAA;ADkRF;AC/QE;EACE,aAAA;ADiRJ;AAuDQ;EAEI,WAAA;EAEA,+DAAA;AAvDZ;AA0DQ;EACI,mBAAA;EAEA,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,uCAAA;AA1DZ;AA4DY;EACI,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AA1DhB;AA6DY;EACI,sDAAA;AA3DhB;AA8DY;EACI,8BAAA;AA5DhB;;AAkEA;EACI,0EAAA;EACA,kCAAA;EACA,2DAAA;AA/DJ;AAiEI;EACI,iCAAA;EACA,8BAAA;EACA,mBAAA;AA/DR;AAiEQ;EACE,WAAA;EACA,eAAA;AA/DV;AAkEQ;EACE,wEAAA;EACA,qBAAA;EACA,iCAAA;AAhEV;AAoEI;EACI,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;ECjZN,wBAAA;EAGA,8BAAA;EACA,qBAAA;AD6UF;AC1UE;EACE,aAAA;AD4UJ;AAiEQ;EAEI,WAAA;EAEA,+DAAA;AAjEZ;AAoEQ;EACI,mBAAA;EAEA,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,uCAAA;AApEZ;AAsEY;EACI,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AApEhB;AAuEY;EACI,sDAAA;AArEhB;AAwEY;EACI,8BAAA;AAtEhB;;AA4EA;EACI,0EAAA;EACA,kCAAA;EACA,qDAAA;AAzEJ;AA2EI;EACE,iCAAA;EACA,8BAAA;EACA,mBAAA;AAzEN;AA2EM;EACE,WAAA;AAzER;AA4EM;EACE,kEAAA;EACA,qBAAA;EACA,iCAAA;AA1ER;AA8EI;EACE,qBAAA;EACA,8BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,0CAAA;EACA,2CAAA;ECrdJ,wBAAA;EAGA,8BAAA;EACA,qBAAA;ADuYF;ACpYE;EACE,aAAA;ADsYJ;AA2EM;EAEE,WAAA;EAEA,+DAAA;AA3ER;AA8EM;EACE,mBAAA;EAEA,0EAAA;EACA,uEAAA;EACA,2EAAA;EAEA,uCAAA;AA9ER;AAgFQ;EACE,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AA9EV","sourcesContent":["@import \"theme/mixins/scrollbars\";\r\n\r\n// Custom variables\r\n// Note:  These ones were added by us and have nothing to do with Ionic CSS Custom Properties\r\n:host {\r\n    --page-margin: var(--app-fair-margin);\r\n    --page-background: var(--app-background);\r\n    --page-border-radius: var(--app-fair-radius);\r\n\r\n    --page-tags-vertical-gutter: 2px;\r\n    --page-tags-horizontal-gutter: 4px;\r\n    --page-places-gutter: 5px;\r\n    --page-friends-gutter: calc(var(--page-margin) / 2);\r\n    --page-visits-gutter: calc(var(--page-margin) / 2);\r\n\r\n    --page-swiper-pagination-space: 140px;\r\n    --page-swiper-pagination-height: 18px;\r\n    --page-pagination-bullet-size: 10px;\r\n\r\n    --page-color: #00AFFF;\r\n}\r\n\r\n// ISSUE: .swiper-pagination gets rendered dynamically. That prevents styling the elements when using the default Angular ViewEncapsulation.None\r\n//        (Angular doesn't add an '_ngcontent' attribute to the .swiper-pagination because it's dynamically rendered)\r\n// FIX:   See: https://stackoverflow.com/a/36265072/1116959\r\n:host ::ng-deep .swiper-pagination {\r\n    height: var(--page-swiper-pagination-height);\r\n    line-height: 1;\r\n    // .swiper-pagination is 18px height, .slide-inner-row has 40px of padding-bottom => bottom = (40px - 18px)/2 = 11px\r\n    bottom: calc((var(--page-swiper-pagination-space) - var(--page-swiper-pagination-height)) / 2);\r\n\r\n\r\n    .swiper-pagination-bullet {\r\n        width: var(--page-pagination-bullet-size);\r\n        height: var(--page-pagination-bullet-size);\r\n        background: white;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n#recommendedViewpoint {\r\n    margin: 0 0 16px 0;\r\n    /* border-radius: 10px; */\r\n    overflow: hidden;\r\n\r\n    .covers {\r\n\r\n        .image-container {\r\n            width: 100%;\r\n            /* Ancho completo */\r\n            height: 0;\r\n            /* Altura inicial */\r\n            padding-bottom: 100%;\r\n            /* Esto crea una relación de aspecto cuadrada */\r\n            position: relative;\r\n            /* Posicionamiento relativo para los hijos absolutos */\r\n            overflow: hidden;\r\n            /* Oculta cualquier parte de la imagen que sobresalga */\r\n\r\n            img {\r\n                position: absolute;\r\n                top: 50%;\r\n                /* Centra la imagen verticalmente */\r\n                left: 50%;\r\n                /* Centra la imagen horizontalmente */\r\n                width: auto;\r\n                /* Ancho completo dentro del contenedor */\r\n                height: 100%;\r\n                /* Altura automática para mantener la relación de aspecto de la imagen */\r\n                transform: translate(-50%, -50%);\r\n                /* Ajuste fino para centrar exactamente la imagen */\r\n                object-fit: cover;\r\n                /* Asegura que la imagen cubra completamente el contenedor */\r\n            }\r\n        }\r\n\r\n        .buttons-container {\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            display: flex;\r\n            gap: 10px;\r\n            /* Espacio entre botones */\r\n            padding: 10px;\r\n            /* Espacio desde el borde superior derecho */\r\n            z-index: 1;\r\n\r\n            ion-button {\r\n                background-color: rgba(255, 255, 255, 0.7);\r\n                /* Blanco con transparencia */\r\n                --opacity: 0.7;\r\n                /* Transparencia para el contenido del botón */\r\n            }\r\n\r\n            ion-icon {\r\n                color: #000;\r\n                /* Color de los iconos */\r\n            }\r\n\r\n        }\r\n\r\n        .icons-container {\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            display: flex;\r\n            gap: 10px;\r\n            /* Espacio entre iconos */\r\n            padding: 12px 20px;\r\n            /* Espacio desde el borde superior derecho */\r\n            z-index: 1;\r\n\r\n            ion-icon {\r\n                font-size: 28px;\r\n                /* Tamaño del icono */\r\n                color: rgba(255, 255, 255, 0.9);\r\n                /* Color blanco con transparencia */\r\n                cursor: pointer;\r\n                /* Cambia el cursor al pasar el mouse */\r\n            }\r\n        }\r\n\r\n\r\n\r\n\r\n    }\r\n\r\n    .bodyRecomended,\r\n    .bodyRecomendedV {\r\n        padding: 24px;\r\n        text-align: center;\r\n        z-index: 20;\r\n        position: relative;\r\n        border-radius: 40px 40px 0 0;\r\n        min-height: 20px;\r\n        background: var(--ion-linear-gradient);\r\n        transition: margin-top 0.4s ease; // Transición suave\r\n\r\n    }\r\n\r\n    .bodyRecomended {\r\n        margin-top: -337px;\r\n\r\n        .title {\r\n            font-size: 28px;\r\n        }\r\n\r\n        .description {\r\n            margin: 24px 0;\r\n        }\r\n    }\r\n\r\n    .bodyRecomendedV {\r\n        margin-top: -52px;\r\n\r\n        .title {\r\n            font-size: 28px;\r\n        }\r\n\r\n        .description {\r\n            margin: 24px 0;\r\n        }\r\n    }\r\n\r\n    .card-content {\r\n        padding: 10px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n\r\n        .title {\r\n            width: 100%;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            flex-direction: row;\r\n            font-size: 18px;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .duration {\r\n            font-size: 14px;\r\n            color: gray;\r\n        }\r\n\r\n        .rating {\r\n            display: flex;\r\n            align-items: center;\r\n            font-size: 14px;\r\n            margin: 0 0 5px 5px;\r\n\r\n            ion-icon {\r\n                margin-right: 8px;\r\n            }\r\n        }\r\n\r\n        .price {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n}\r\n\r\n.loading-shell {\r\n    width: 100%;\r\n    height: 0;\r\n    padding-bottom: 100%;\r\n    /* Para crear un contenedor cuadrado */\r\n    background-color: #f5f5f5;\r\n    /* Color de fondo del shell */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.loading {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #ccc;\r\n    /* Color gris para el efecto de carga */\r\n    opacity: 0.4;\r\n    /* Opacidad para el efecto de carga */\r\n    animation: pulse 1.5s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n    0% {\r\n        opacity: 1;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0.4;\r\n    }\r\n\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.loaded {\r\n    opacity: 1;\r\n    /* Mostrar la imagen cuando esté cargada */\r\n    transition: opacity 0.3s ease-in-out;\r\n}\r\n\r\n\r\n.install-banner {\r\n    color: #fff;\r\n    padding: 4px;\r\n    text-align: center;\r\n    top: 0;\r\n    width: 100%;\r\n    z-index: 1000;\r\n\r\n    ion-item {\r\n        background: rgba(255, 255, 255, 0.2);\r\n        /* Fondo blanco con 20% de opacidad */\r\n        border-radius: 8px;\r\n        /* Opcional: para redondear los bordes */\r\n        margin-bottom: 10px;\r\n        /* Espaciado entre los elementos */\r\n    }\r\n\r\n    ion-avatar img {\r\n        opacity: 0.9;\r\n        /* Imagen con 90% de opacidad */\r\n    }\r\n\r\n    ion-label h3,\r\n    ion-label p {\r\n        opacity: 0.9;\r\n        /* Texto con 90% de opacidad */\r\n    }\r\n\r\n    ion-button {\r\n        opacity: 0.9;\r\n        /* Botón con 90% de opacidad */\r\n    }\r\n\r\n    ion-icon {\r\n        opacity: 0.9;\r\n        /* Iconos con 90% de opacidad */\r\n    }\r\n}\r\n\r\n.install-banner a {\r\n    color: #00ff00;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n}\r\n\r\n.install-banner button {\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    margin-left: 20px;\r\n}\r\n\r\nion-avatar {\r\n    --border-radius: 4px;\r\n}\r\n\r\n\r\n.more-experiences-section {\r\n    margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n    padding-bottom: var(--page-margin);\r\n    /* border-bottom: 1px solid var(--ion-color-light-shade); */\r\n\r\n    .heading-row {\r\n        margin-bottom: var(--page-margin);\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    \r\n        .heading-title {\r\n          margin: 0px;\r\n          flex-basis: 68%;\r\n        }\r\n    \r\n        .heading-call-to-action {\r\n          /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */\r\n          text-decoration: none;\r\n          color: var(--ion-color-secondary);\r\n        }\r\n      }\r\n\r\n    .experiences-row {\r\n        --ion-grid-columns: 7; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 2 = 7 cols)\r\n        --ion-grid-column-padding: 0px;\r\n\r\n        flex-wrap: nowrap;\r\n        overflow-x: scroll;\r\n        will-change: scroll-position;\r\n        margin-left: calc(var(--page-margin) * -1);\r\n        margin-right: calc(var(--page-margin) * -1);\r\n\r\n        @include hide-scrollbars();\r\n\r\n        &::before,\r\n        &::after {\r\n            content: '';\r\n            // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n            flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));\r\n        }\r\n\r\n        .experience-item {\r\n            --col-item-width: 3;\r\n            // SSR fix: Override ion-col styles\r\n            flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n\r\n            padding: 0px var(--page-friends-gutter);\r\n\r\n            .experience-name {\r\n                display: block;\r\n                text-align: left;\r\n                margin: var(--page-margin) 0px;\r\n                font-size: 14px;\r\n                padding-left: 4px;\r\n            }\r\n\r\n            app-image-shell.experience-picture {\r\n                --image-shell-border-radius: var(--page-border-radius);\r\n            }\r\n\r\n            .experience-name>app-text-shell {\r\n                --text-shell-line-height: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.guides-section {\r\n    margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n    padding-bottom: var(--page-margin);\r\n    /* border-bottom: 1px solid var(--ion-color-light-shade); */\r\n\r\n    .heading-row {\r\n        margin-bottom: var(--page-margin);\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    \r\n        .heading-title {\r\n          margin: 0px;\r\n          flex-basis: 68%;\r\n        }\r\n    \r\n        .heading-call-to-action {\r\n          /* padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4); */\r\n          text-decoration: none;\r\n          color: var(--ion-color-secondary);\r\n        }\r\n      }\r\n\r\n    .guides-row {\r\n        --ion-grid-columns: 7; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 2 = 7 cols)\r\n        --ion-grid-column-padding: 0px;\r\n\r\n        flex-wrap: nowrap;\r\n        overflow-x: scroll;\r\n        will-change: scroll-position;\r\n        margin-left: calc(var(--page-margin) * -1);\r\n        margin-right: calc(var(--page-margin) * -1);\r\n\r\n        @include hide-scrollbars();\r\n\r\n        &::before,\r\n        &::after {\r\n            content: '';\r\n            // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n            flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));\r\n        }\r\n\r\n        .guide-item {\r\n            --col-item-width: 5;\r\n            // SSR fix: Override ion-col styles\r\n            flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n            max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n\r\n            padding: 0px var(--page-friends-gutter);\r\n\r\n            .guide-name {\r\n                display: block;\r\n                text-align: left;\r\n                margin: var(--page-margin) 0px;\r\n                font-size: 14px;\r\n                padding-left: 4px;\r\n            }\r\n\r\n            app-image-shell.guide-picture {\r\n                --image-shell-border-radius: var(--page-border-radius);\r\n            }\r\n\r\n            .guide-name>app-text-shell {\r\n                --text-shell-line-height: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.user-friends-section {\r\n    margin: calc(var(--page-margin) * 2) var(--page-margin) var(--page-margin);\r\n    padding-bottom: var(--page-margin);\r\n    border-bottom: 1px solid var(--ion-color-light-shade);\r\n  \r\n    .heading-row {\r\n      margin-bottom: var(--page-margin);\r\n      justify-content: space-between;\r\n      align-items: center;\r\n  \r\n      .details-section-title {\r\n        margin: 0px;\r\n      }\r\n  \r\n      .heading-call-to-action {\r\n        padding: calc(var(--page-margin) / 2) calc(var(--page-margin) / 4);\r\n        text-decoration: none;\r\n        color: var(--ion-color-secondary);\r\n      }\r\n    }\r\n  \r\n    .friends-row {\r\n      --ion-grid-columns: 7; // We want to show three friends and a half. Each friend fills 2 cols => (3.5 * 2 = 7 cols)\r\n      --ion-grid-column-padding: 0px;\r\n  \r\n      flex-wrap: nowrap;\r\n      overflow-x: scroll;\r\n      will-change: scroll-position;\r\n      margin-left: calc(var(--page-margin) * -1);\r\n      margin-right: calc(var(--page-margin) * -1);\r\n  \r\n      @include hide-scrollbars();\r\n  \r\n      &::before,\r\n      &::after {\r\n        content: '';\r\n        // .friend-item has 8px of side padding, we need an extra 4px at the beginning and end to fill the 12px side margin of the view\r\n        flex: 0 0 calc(var(--page-margin) - var(--page-friends-gutter));\r\n      }\r\n  \r\n      .friend-item {\r\n        --col-item-width: 2;\r\n        // SSR fix: Override ion-col styles\r\n        flex: 0 0 calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n        width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n        max-width: calc(calc(var(--col-item-width) / var(--ion-grid-columns, 12)) * 100%);\r\n  \r\n        padding: 0px var(--page-friends-gutter);\r\n  \r\n        .friend-name {\r\n          display: block;\r\n          text-align: center;\r\n          margin: var(--page-margin) 0px;\r\n          font-size: 14px;\r\n        }\r\n      }\r\n    }\r\n  }","// Hide scrollbars: https://stackoverflow.com/a/38994837/1116959\r\n@mixin hide-scrollbars() {\r\n  // IE 10+\r\n  -ms-overflow-style: none;\r\n\r\n  // Firefox\r\n  overflow: -moz-scrollbars-none;\r\n  scrollbar-width: none;\r\n\r\n  // Safari and Chrome\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
